import React, { useState } from "react";
import { ID_PASSWORD_CATEGORY_LIST } from "../../../../constant/idPasswordCategoryList";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { LoginResponseType } from "../../../../redux/auth/authTypes";
import { IdPasswordManagerListType } from "../../../../redux/stcoTools/stcoToolsType";
import { formateDateWithTime } from "../../../../utils/commonFunctions";
import { CircularAvatar } from "../../../commons";
import { PaperClipIcon } from "../../../Icon";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  idPasswordManagerList: [] | IdPasswordManagerListType[];
  tableHeaders: [] | TableHeadersType[];
  handleShowConfirmationModal: (data: number) => void;
  deleteIdPasswordRecord?: (data: number) => void;
  handleEditIdPasswordData: (data: any) => void;
  loginData: LoginResponseType;
  isEditIdPasswordManagerPresent?:boolean;
  isEditClientIdPasswordManagerPresent?:boolean;
};

const IdPasswordTableData = ({
  idPasswordManagerList,
  tableHeaders,
  loginData,
  handleEditIdPasswordData,
  handleShowConfirmationModal,
  deleteIdPasswordRecord,
  isEditIdPasswordManagerPresent,
  isEditClientIdPasswordManagerPresent
}: AppProps) => {
  return (
    <>
      {idPasswordManagerList?.length > 0 &&
        idPasswordManagerList?.map((dataItem: any) => {
          const accessMemberData = dataItem?.access_member_ids?.filter(
            (e: any) => e?.id !== loginData?.user_id
          );
          const category = ID_PASSWORD_CATEGORY_LIST?.filter((e: any) => {
            if (e.value === dataItem?.category) {
              return e.label;
            }
          });

          return (
            <tr>
              {tableHeaders?.length &&
                tableHeaders?.map((item: any) => {
                  if (item.value === "access_member_ids") {
                    return (
                      <td className="text-start" style={{ minWidth: "200px" }}>
                        {accessMemberData?.map((e: any) => (
                          <div className="d-flex justify-content-sm-start mb-1 ml-2">
                            <CircularAvatar
                              name={e?.user_name}
                              image={e?.profile_pic?.file_url}
                            />
                            <span
                              style={{ marginLeft: "10px", marginTop: "2px" }}
                            >
                              {e.user_name}
                            </span>
                          </div>
                        ))}
                      </td>
                    );
                  } else if (item.value === "client_name") {
                    return (
                      <td className="text-start">
                        {" "}
                        {`${dataItem?.client_name} (${dataItem?.client_code})`}
                      </td>
                    );
                  } else if (item.value === "category") {
                    return (
                      <td className="text-start"> {category[0]?.label}</td>
                    );
                  } else if (item.value === "url") {
                    return (
                      <td className="text-start">
                        <div
                          style={{ overflowWrap:"anywhere", minWidth: "250px" }}
                        >
                          {dataItem?.url?dataItem?.url:"--/--"}
                        </div>
                      </td>
                    );
                  } else if (item.value === "updated_at") {
                    return (
                      <td className="text-start">
                        <div className="d-flex flex-column">
                          {dataItem?.updated_by}
                          <span className="due-date-text">
                            {formateDateWithTime(dataItem?.updated_at)}
                          </span>
                        </div>
                      </td>
                    );
                  } else if (dataItem[item.value]) {
                    return (
                      <td className="text-start"> {dataItem[item.value]}</td>
                    );
                  } 
                  else if (item?.value === "files") {
                    return dataItem?.uploads?.length ? (
                      <td className="position-relative">
                        <span>
                          <PaperClipIcon />
                          <span className="badge count-badge">
                            {dataItem?.uploads?.length}
                          </span>
                        </span>
                      </td>
                    ) : (
                      <td> --/-- </td>
                    );
                  }
                  else if (item.value == "edit") {
                    return (
                      <td style={{ minWidth: "70px", textAlign: "center" }}>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="send-email-tooltip">
                                    Edit
                                  </Tooltip>
                                }
                              >
                        <span
                          className="d-inline-block pointer"
                          onClick={() => handleEditIdPasswordData?.(dataItem)}
                          >
                          {(isEditIdPasswordManagerPresent || isEditClientIdPasswordManagerPresent) && 
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <i className="fas fa-pen"></i>
                          </div>
                          }
                        </span>
                        </OverlayTrigger>
                        {/* {(loginData?.email===dataItem?.created_by_email_id) && <span
                  className="d-inline-block pointer ml-2"
                  onClick={() => handleShowConfirmationModal(dataItem?.record_id)}
                >
                  <div
                    style={{
                      color: "#d43",
                      fontSize: 18,
                    }}
                  >
                    <i className="fas fa-trash"></i>
                  </div>
                </span>} */}
                      </td>
                    );
                  } else {
                    return <td className="text-start"> --/-- </td>;
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default IdPasswordTableData;
